import React from 'react';

export const NotFound404: React.FC = () => (
  <div className="d-flex justify-content-center align-items-center">
    <h1>Página Não Encontrada.</h1>
    <h2>Verifique o endereço digitado e tente novamente.</h2>
  </div>
);
